// Registry for the dialogs component

import type { ComponentType } from 'react';
import BlockedUsersDialog from './BlockedUsersDialog';
import BlockedTwitchTermsDialog from './BlockedTwitchTermsDialog';
import BuyLoonsDialog from './BuyLoonsDialog';
import ConnectionsDialog from './ConnectionsDialog';
import CustomWordsDialog from './CustomWordsDialog';
import LoginDialog from './LoginDialog';
import LoonHistoryDialog from './LoonHistoryDialog';
import PoppyChatCommandsDialog from './PoppyChatCommandsDialog';
import RapidReloadDialog from './RapidReloadDialog';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';
import type { LibraryDialog } from '../libraryRouteTypes';

type LibraryOutletDialogEntry = Readonly<{
  key: LibraryDialog;
  component: ComponentType<LibraryDialogOutletProps>;
}>;

/** Stable mount order for outlet dialogs and their components. */
export const LIBRARY_OUTLET_DIALOGS = [
  { key: 'login', component: LoginDialog },
  { key: 'buy-loons', component: BuyLoonsDialog },
  { key: 'loon-history', component: LoonHistoryDialog },
  { key: 'rapid-reload', component: RapidReloadDialog },
  { key: 'connections', component: ConnectionsDialog },
  { key: 'chat-commands', component: PoppyChatCommandsDialog },
  { key: 'blocked-users', component: BlockedUsersDialog },
  { key: 'blocked-twitch-terms', component: BlockedTwitchTermsDialog },
  { key: 'custom-words', component: CustomWordsDialog },
] as const satisfies ReadonlyArray<LibraryOutletDialogEntry>;

export type LibraryOutletDialogKey =
  (typeof LIBRARY_OUTLET_DIALOGS)[number]['key'];
